var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 299,
    height: 299,
    viewBox: "0 0 299 299",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 149.171,
    cy: 149.133,
    r: 149.133,
    fill: "url(#paint0_linear_1879_7231)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 149,
    cy: 150,
    r: 100,
    fill: "#232323"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149.5 253C92.3385 253 46 206.661 46 149.5C46 92.3385 92.3385 46 149.5 46C206.661 46 253 92.3385 253 149.5C253 206.661 206.661 253 149.5 253Z",
    stroke: "#100F11",
    strokeWidth: 20.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M149.5 190.9C126.635 190.9 108.1 172.364 108.1 149.5C108.1 126.635 126.635 108.1 149.5 108.1C172.364 108.1 190.9 126.635 190.9 149.5C190.9 172.364 172.364 190.9 149.5 190.9Z",
    fill: "#FBE025",
    stroke: "#100F11",
    strokeWidth: 15.9231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M149.5 149.5H149.397H149.5Z",
    fill: "#232323"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M149.5 149.5H149.397",
    stroke: "#100F11",
    strokeWidth: 20.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1924 152.153C75.1924 131.207 83.8172 112.725 97.3704 100.404L75.1924 152.153Z",
    fill: "#232323"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1924 152.153C75.1924 131.207 83.8172 112.725 97.3704 100.404",
    stroke: "#100F11",
    strokeWidth: 15.9231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M223.045 152.155C223.045 173.101 214.42 191.583 200.867 203.904L223.045 152.155Z",
    fill: "#232323"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M223.045 152.155C223.045 173.101 214.42 191.583 200.867 203.904",
    stroke: "#100F11",
    strokeWidth: 15.9231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1879_7231",
    x1: 149.171,
    y1: 0,
    x2: 149.171,
    y2: 298.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.254808,
    stopColor: "#132B47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#4B73A1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar2);
export default __webpack_public_path__ + "static/media/avatar2.dd4f24f8e32f62c85d3a423ca50f566f.svg";
export { ForwardRef as ReactComponent };